import o2switch from "../../assets/img/hosting/o2switch.webp";
import bahnhof from "../../assets/img/hosting/bahnhof.webp";
import infomaniak from "../../assets/img/hosting/infomaniak.webp";
import ovh from "../../assets/img/hosting/ovh.webp";
import heroku from "../../assets/img/hosting/heroku.webp";
import netlify from "../../assets/img/hosting/netlify.webp";
import aws from "../../assets/img/hosting/aws.webp";
import github from "../../assets/img/hosting/github.webp";
import bluehost from "../../assets/img/hosting/bluehost.webp";
import hostinger from "../../assets/img/hosting/hostinger.webp";
import njalla from "../../assets/img/hosting/njalla.webp";
import firebase from "../../assets/img/hosting/firebase.webp";
import vercel from "../../assets/img/hosting/vercel.webp";
import surge from "../../assets/img/hosting/surge.webp";
import render from "../../assets/img/hosting/render.webp";
import stormkit from "../../assets/img/hosting/stormkit.webp";
import azure from "../../assets/img/hosting/azure.webp";
import hostman from "../../assets/img/hosting/hostman.webp";
import fleek from "../../assets/img/hosting/fleek.webp";
import begin from "../../assets/img/hosting/begin.webp";
import kintohub from "../../assets/img/hosting/kintohub.webp";
import fosshost from "../../assets/img/hosting/fosshost.webp";

export const DataHosting = [
  {
    title: "O2switch",
    path: "https://www.o2switch.fr/",
    cName: "icon",
    icon: o2switch,
    description:
      "My hosting provider for a long time, only €5 a month $~5.50 for all unlimited, very good support and easy to host a Node application on it. If I have to pay for a basic hosting provider, I will choose them.",
  },
  {
    title: "Bahnhof",
    path: "https://www.bahnhof.net/",
    cName: "icon",
    icon: bahnhof,
    description:
      "Your complete cloud built on the market leading platform of your choice. All run in modern, environmentally friendly data centers within Swedish borders and under Sweden's excellent free speech and data protection laws.Our data centers - and your cloud - are connected directly to all major European internet exchange points through our own high-performance network.",
  },
  {
    title: "Infomaniak",
    path: "https://www.infomaniak.com/",
    cName: "icon",
    icon: infomaniak,
    description:
      "Host your data in Switzerland with optimum guarantees of security and confidentiality. It's a big hosting provider.",
  },
  {
    title: "Ovh",
    path: "https://www.ovh.com/world/",
    cName: "icon",
    icon: ovh,
    description:
      "OVHcloud puts complete freedom in the hands of technologists and businesses, for anyone to master right from the start.  We are a global technology company serving developers, entrepreneurs, and businesses with the dedicated server, software and infrastructure building blocks to manage, secure and scale their data.",
  },
  {
    title: "Heroku",
    path: "https://www.heroku.com/",
    cName: "icon",
    icon: heroku,
    description:
      "Build data-driven apps with fully managed data services. Officially supported languages : Node.js, Ruby, Java, Php, Python, Go, Scala, Clojure.",
  },
  {
    title: "Netlify",
    path: "https://www.netlify.com/",
    cName: "icon",
    icon: netlify,
    description:
      "The fastest way to build the fastest sites. 1,000,000+ developers & businesses use Netlify to run web projects at global scale—without servers, devops, or costly infrastructure.",
  },
  {
    title: "Aws",
    path: "https://aws.amazon.com/fr/?nc2=h_lg",
    cName: "icon",
    icon: aws,
    description:
      "Amazon web service is a platform that offers flexible, reliable, scalable, easy-to-use and cost-effective cloud computing solutions.",
  },
  {
    title: "Github(pages)",
    path: "https://pages.github.com/",
    cName: "icon",
    icon: github,
    description:
      "Hosted directly from your GitHub repository. Just edit, push, and your changes are live.",
  },
  {
    title: "Bluehost",
    path: "https://www.bluehost.com/",
    cName: "icon",
    icon: bluehost,
    description:
      "Bluehost is a leading web hosting solutions company. Since our founding in 2003, Bluehost has continually innovated new ways to deliver on our mission: to empower people to fully harness the web. Based in Orem, Utah, we provide comprehensive tools to millions of users throughout the world so anyone, novice or pro, can get on the web and thrive with our web hosting packages.",
  },
  {
    title: "Hostinger",
    path: "https://www.hostinger.com/",
    cName: "icon",
    icon: hostinger,
    description:
      "Hostinger is a free hosting provider. The large group offers free web hosting, premium hosting, domain booking, Server, SSL…",
  },
  {
    title: "Njalla",
    path: "https://njal.la/",
    cName: "icon",
    icon: njalla,
    description:
      "Finally, a privacy-aware domain service. Njalla protects you from ferocious domain predators.",
  },
  {
    title: "Firebase",
    path: "https://firebase.google.com/",
    cName: "icon",
    icon: firebase,
    description:
      "Firebase is a Backend-as-a-Service — BaaS — that started as a YC11 startup and grew up into a next-generation app-development platform on Google Cloud Platform.",
  },
  {
    title: "Vercel",
    path: "https://vercel.com/",
    cName: "icon",
    icon: vercel,
    description:
      "Vercel is the best place to deploy any frontend app. Start by deploying with zero configuration to our global edge network. Scale dynamically to millions of pages without breaking a sweat.",
  },
  {
    title: "Surge",
    path: "https://surge.sh/",
    cName: "icon",
    icon: surge,
    description:
      "Static web publishing for Front-End Developers. Simple, single-command web publishing. Publish HTML, CSS, and JS for free, without leaving the command line.",
  },
  {
    title: "Render",
    path: "https://render.com/",
    cName: "icon",
    icon: render,
    description:
      "Instant Deploys For All Your Apps. Select a service type, Deploy in seconds, Update automatically.",
  },
  {
    title: "Stormkit",
    path: "https://www.stormkit.io/",
    cName: "icon",
    icon: stormkit,
    description:
      "Powerful infrastructure for modern javascript apps. Stormkit integrates perfectly with your git flow. It builds, deploys and scales your javascript apps seamlessly. Deploy now for free.",
  },
  {
    title: "Azure",
    path: "https://azure.microsoft.com/fr-fr/",
    cName: "icon",
    icon: azure,
    description:
      "The Azure cloud platform is more than 200 products and cloud services designed to help you bring new solutions to life—to solve today’s challenges and create the future. Build, run, and manage applications across multiple clouds, on-premises, and at the edge, with the tools and frameworks of your choice.",
  },
  {
    title: "Hostman",
    path: "https://hostman.com/",
    cName: "icon",
    icon: hostman,
    description:
      "Hostman lets you launch your apps in just a few clicks using a friendly interface. The pricing is fair and transparent. Hostman works on top of AWS and DigitalOcean to provide the best reliability possible.",
  },
  {
    title: "Fleek",
    path: "https://fleek.co/",
    cName: "icon",
    icon: fleek,
    description:
      "Fleek makes it easy to build and integrate privacy, encryption, and p2p functionality into your sites, web & native apps. Built on top of IPFS, Textile, & Filecoin, our suite of products allow you to effortlessly take advantage of the benefits of these new technologies.",
  },
  {
    title: "Begin",
    path: "https://begin.com/",
    cName: "icon",
    icon: begin,
    description:
      "Effortlessly ship web apps & APIs on AWS. Begin makes serverless absurdly easy. No servers, No config, No sweat. The best of AWS in seconds.",
  },
  {
    title: "KintoHub",
    path: "https://www.kintohub.com/",
    cName: "icon",
    icon: kintohub,
    description:
      "KintoHub is an all-in-one platform to combine and deploy your backend services, websites, cron jobs, databases and everything your app needs in one place. Support Node, Golang, Python and more.",
  },
  {
    title: "Fosshost",
    path: "https://fosshost.org/",
    cName: "icon",
    icon: fosshost,
    description:
      "Fosshost.org is a recognized and not-for-profit provider of free to use and accessible cloud-hosting services to the free and open source software community.",
  },
];
